const lagescoresColorsIntensity = {
  Wohnlage: {
    1: '#FFE0A3',
    2: '#FCC569',
    3: '#FF9912',
    4: '#EC671A',
    5: '#CA220E',
  },
  ÖPNV: {
    1: '#DAEDEB',
    2: '#BFE0DC',
    3: '#B0CACA',
    4: '#77B4B4',
    5: '#778181',
  },
  Kultur: {
    1: '#F5EBF5',
    2: '#EAD9E9',
    3: '#DDC3DC',
    4: '#C7A2C4',
    5: '#AC73A8',
  },
  Internet: {
    1: '#C8EDE8',
    2: '#93D2CB',
    3: '#539EB2',
    4: '#2C3FA7',
    5: '#030F54',
  },
  Nahversorgung: {
    1: '#ECE1F6',
    2: '#DAC9EE',
    3: '#C1B4EF',
    4: '#A192D2',
    5: '#7B80AD',
  },
};

export default lagescoresColorsIntensity;
